<template>
  <div class="booth-templates-page-wrap">
    <transition name="fade">
      <add-or-edit-template-modal
        v-if="showModal"
        :template="editingTemplateObj"
        @close-modal="showModal=false"
        @get-templates="getTemplates"
      ></add-or-edit-template-modal>
    </transition>
    <h1>Templates</h1>
    <button class="add-button" @click="unsetEditingTemplateObjAndShowModal">Add New Template</button>
    <div class="template-rows-wrap" v-if="templates.length > 0">
      <div class="each-template"
        v-for="(template, index) in templates"
        :key="index"
      >
        <div class="template-name">
          {{template.tmp_name}}
        </div>
        <div class="template-thumbnail-wrap">
          <template-thumbnail
            :selected="parseCoords(template.tmp_elems)"
          ></template-thumbnail>
        </div>
        <div class="buttons">
          <button class="edit-button" @click="setEditingTemplateAndShowModal(template)">{{$t('button.editTemplate')}}</button>
          <button class="delete-button" @click="confirmDelete(template.tmp_id)">{{$t('button.deleteTemplate')}}</button>
        </div>
      </div>
    </div>
    <p v-else>No templates</p>
  </div>
</template>

<script>
import AddOrEditTemplateModal from '../../components/admin/booth-template/AddOrEditTemplateModal'
import TemplateThumbnail from '../../components/admin/booth-template/TemplateThumbnail';
import api from '@/api'
export default {
  components: {
    TemplateThumbnail,
    AddOrEditTemplateModal
  },
  data () {
    return {
      templates: [],
      editingTemplateObj: null,
      tmpIdToDelete: null,
      showModal: false
    }
  },
  methods: {
    async getTemplates () {
      try {
        this.startLoading();
        const res = await api.getTemplates();
        this.templates = res.data.templates;
      } catch (error) {
        this.handleError();
      }
      this.stopLoading();
    },
    parseCoords (templateCoords) {
      let coordsArray = [];
      templateCoords = JSON.parse(templateCoords);
      templateCoords = typeof templateCoords === "object" ? templateCoords : JSON.parse(templateCoords);
      for (let i = 0; i < [templateCoords][0].length; i++) {
        coordsArray.push([templateCoords][0][i])
      }
      return coordsArray;
    },
    setEditingTemplateAndShowModal (template) {
      this.editingTemplateObj = template;
      this.showModal = true;
    },
    unsetEditingTemplateObjAndShowModal () {
      this.editingTemplateObj = null;
      this.showModal = true;
    },
    confirmDelete (tmpId) {
      this.tmpIdToDelete = tmpId;
      let obj = {
				okButton: "Delete",
				title: "Are you sure you want to delete this template?",
        okCallback: this.deleteTemplate
			};
			this.EventBus.$emit("confirm", obj);
    },
    async deleteTemplate () {
      try {
        this.startLoading();
        await api.deleteTemplate({
          tmp_id: this.tmpIdToDelete
        });
        this.$emit('success', this.$t(`templates.deleted`))
        this.getTemplates();
      } catch (error) {
        this.handleError();
      }
      this.stopLoading();
    }
  },
  mounted () {
    this.getTemplates();
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
h1 {
  margin: 0;
}
.booth-templates-page-wrap {
  padding: 3% 15% 3% 3%;
  background-color: #e5e5e5;
}
.booth-img {
  max-width: 30%;
  max-height: 27vh;
  position: relative;
  background: lightgray;
}
.template-rows-wrap {
  display: flex;
  flex-direction: column;
}
.each-template {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
}
.template-thumbnail-wrap {
  width: 120px;
  height: 60px;
  margin: 0 20px;
}
.buttons, .template-name {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
}
.buttons {
  margin-left: 20px;
}
.template-name {
  font-weight: 600;
  font-size: 1.3em;
  width: 25%;
  word-break: break-all;
}
button {
  cursor: pointer;
  white-space: nowrap;
  border: none;
  padding: 8px 23px;
  border-radius: 100px;
  font-size: 11px;
  margin: 0 10px;
  outline: none;
  color: white;
}
.edit-button {
  background-color: var(--button-color-blue);
}
.delete-button {
  background-color: var(--button-color-bright-red);
}
.add-button {
  background-color: var(--button-color-blue);
  margin: 30px 0;
}

.fade-enter, 
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}
</style>